/**
 * TtfTrimmedCmapSubTable.ts class for EJ2-PDF
 */
var TtfTrimmedCmapSubTable = /** @class */ (function () {
    function TtfTrimmedCmapSubTable() {
    }
    return TtfTrimmedCmapSubTable;
}());
export { TtfTrimmedCmapSubTable };
